import { render, staticRenderFns } from "./interview-simulator.vue?vue&type=template&id=5caeb8a2&scoped=true&"
import script from "./interview-simulator.vue?vue&type=script&lang=js&"
export * from "./interview-simulator.vue?vue&type=script&lang=js&"
import style0 from "./interview-simulator.vue?vue&type=style&index=0&id=5caeb8a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caeb8a2",
  null
  
)

export default component.exports